import { useRouter } from 'next/router';

import { Category } from 'models/Category';

import { useCitySelection } from 'hooks/useCitySelection';
import { useSWRGet } from 'hooks/useSWRGet';

export const useCategory = () => {
  const router = useRouter();
  const { selectedCity } = useCitySelection();

  const location =
    router.query.category === 'telemedicina' ? '' : `?location=${selectedCity}`;

  const { data, error } = useSWRGet<Category>(
    `/category/${router.query.category}${location}`,
  );

  return {
    categoryData: data,
    isCategoryLoading: !error && !data,
    categoryError: error,
  };
};
